import BillIconSvg from './svg/billIcon.svg?url';

export interface IBillIconProps {
	size?: number;
}

export function BillIcon({ size = 24 }: IBillIconProps) {
	return <img src={BillIconSvg} alt="bill icon" width={size} height={size} />;
}
